/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { CostCenterDetailsDto } from '../model/cost-center-details.dto';

export const CostCenterDetailsMapper = entity<CostCenterDetailsDto>();
